import { connect } from 'react-redux';
import { getKBSearchResults } from 'app/modules';
import DropDownSearchResults from 'presentation/components/__demo__/DropDownSearchResults.jsx';

export const mapStateToProps = (state, props) => {
  return {
    ...props,
    searchResults: getKBSearchResults(state),
  };
};

const DropDownSearchResultsContainer = connect(mapStateToProps)(DropDownSearchResults);

export default DropDownSearchResultsContainer;
